import { ChevronDown } from 'lucide-react'

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui'
import { cn } from '@/lib/utils'

export type PeriodOption = {
  label: string
  value: string
}

const DEFAULT_OPTIONS: PeriodOption[] = [
  { label: 'All Time', value: 'all' },
  { label: 'Last 6 months', value: '6m' },
  { label: 'Last 3 months', value: '3m' },
  { label: 'Last 1 month', value: '1m' },
  { label: 'Last Week', value: '1w' },
  { label: 'Today', value: 'today' },
]

interface PeriodDropdownProps {
  value: string
  onChange: (value: string) => void
  options?: PeriodOption[]
  className?: string
}

export const PeriodDropdown: React.FC<PeriodDropdownProps> = ({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  className,
}) => {
  const selectedLabel = options.find((o) => o.value === value)?.label || value

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className={cn(
            'flex w-[329px] items-center gap-2.5 rounded-3xl border data-[state=open]:bg-gradient-6 border-white/20 bg-white/20 px-[18px] py-3',
            '[&_svg]:transition-transform [&_svg]:duration-200 data-[state=open]:[&_svg]:rotate-180 justify-center',
            className,
          )}
        >
          <span className="text-button-m text-monochrome-1 whitespace-nowrap">
            {selectedLabel}
          </span>
          <ChevronDown className="size-[18px] shrink-0 text-monochrome-1" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="min-w-[160px] w-[var(--radix-dropdown-menu-trigger-width)] p-2">
        {options.map((option) => (
          <DropdownMenuItem
            key={option.value}
            className={cn(
              'text-button-m text-monochrome-1 hover:opacity-70 focus:opacity-70',
              option.value === value && 'text-accent-1',
            )}
            onClick={() => onChange(option.value)}
          >
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
